import { useEffect } from 'react'

import { useSetMixedMediaCapabilityInputs } from '../store/capabilitySlice/hooks'
import { useMixedMediaCapability } from './useMixedMediaCapability'

/**
 * Seeds the Zustand capability slice from `useMixedMediaCapability()` so
 * legacy Flux code (which cannot use hooks) can read the same gates via
 * `getMixedMediaCapabilityForService`. Mount once per composer session,
 * alongside the other store bridges.
 *
 * Returns `isReady` so callers that dispatch capability-gated Flux mutations
 * during initial hydration (e.g. `useLoadLegacyComposerStore`) can defer
 * until the slice actually holds the resolved value, instead of reading the
 * `orgEnabled: false` default and permanently discarding attached media a
 * capable org was entitled to keep.
 */
export function useMixedMediaCapabilityBridge(): { isReady: boolean } {
  const { orgEnabled, isReady } = useMixedMediaCapability()
  const setMixedMediaCapabilityInputs = useSetMixedMediaCapabilityInputs()

  useEffect(() => {
    setMixedMediaCapabilityInputs({ orgEnabled })
  }, [orgEnabled, setMixedMediaCapabilityInputs])

  return { isReady }
}
